import Layout from 'antd/es/layout';
import styled, { css } from 'styled-components';

import Button from '@components/Button';

export const Wrapper = styled.div`
  display: flex;
`;

export const StyledLayout = styled(Layout)<{
  isListing?: boolean;
  $alignVertical?: boolean;
}>`
  &&& {
    background: ${({ $alignVertical, theme }) =>
      $alignVertical ? 'transparent' : theme.palette.white};
    margin-top: 38px;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      margin-top: 12px;
    }

    ${({ isListing }) =>
      isListing &&
      css`
        margin-top: 0px;
      `}
  }
`;

export const StyledContent = styled.div.withConfig({
  shouldForwardProp: (prop) => !['alignVertical'].includes(prop),
})<{ alignVertical?: boolean }>`
  display: flex;
  flex-direction: ${({ alignVertical }) => (alignVertical ? 'column' : 'row')};

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
  }
`;
export const StyledButton = styled(Button).withConfig({
  shouldForwardProp: (prop) => !['alignVertical'].includes(prop),
})<{ alignVertical?: boolean }>`
  &&& {
    margin-top: ${({ alignVertical }) => (alignVertical ? '8px' : '0px')};
    width: ${({ alignVertical }) =>
      alignVertical ? '100%' : '119px'} !important;

    height: 56px !important;

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
      width: 100% !important;
      margin-top: 8px;
    }
    border: none;
    &:disabled {
      opacity: 0.8 !important;
    }
  }
`;

export const Element = styled.div`
  margin-left: 0px;
`;

export const InputElement = styled.div.withConfig({
  shouldForwardProp: (prop) => !['alignVertical', 'isListing'].includes(prop),
})<{
  isListing?: boolean;
  alignVertical?: boolean;
}>`
  width: ${({ isListing }) => (isListing ? '528px' : '500px')};
  margin-right: 12px;
  ${({ alignVertical }) => alignVertical && `width: 100%; margin: 0 0 12px;`};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    width: 100%;
    margin: 0px 0px 12px;
  }
`;

export const ButtonWrapper = styled.div``;
